import { lazy } from 'react';
import { PROVIDER_TYPE } from 'constants/global';
import { loadPaymentMethodModule } from './activation';

export const LazyBBVA = lazy(() => loadPaymentMethodModule(PROVIDER_TYPE.BANCOMER));
export const LazyMercadoPago = lazy(() => loadPaymentMethodModule(PROVIDER_TYPE.MERCADO_PAGO));
export const LazyPaymentReference = lazy(() => loadPaymentMethodModule(PROVIDER_TYPE.PAYCASH));
